import { getSelectedSupplierQuote, computeSupplierQuoteTotal } from './quoteHelpers';

export const buildOrdersPageRecords = (offers = [], inquiries = [], quotes = []) => [
  ...offers,
  ...inquiries.map((inquiry) => ({ ...inquiry, type: 'Inquiry' })),
  ...quotes.map((quote) => ({ ...quote, type: 'Quote' })),
];

export const getOrdersPagePriorityValue = (record) => (
  record?.type === 'Inquiry' ? record.priority : null
);

export const getQuotedAmount = (record, suppliers = []) => {
  // New one-product-per-Quote pipeline: amount comes from the selected
  // Supplier_Quote line's unit price * qty + shipping, not a per-item
  // `quotation` sub-object. `supplierQuotes` entries are `{ status, lines }`
  // (see quoteHelpers.js), not a flat cost object — go through
  // getSelectedSupplierQuote/computeSupplierQuoteTotal rather than reading
  // `unitPrice` directly off the entry.
  if (Array.isArray(record.suppliers)) {
    const selected = getSelectedSupplierQuote(record, null, suppliers);
    if (!selected) return null;
    return computeSupplierQuoteTotal(selected, record.quantity);
  }
  const quotedItems = (record.items || []).filter((item) => item.quotation);
  if (quotedItems.length === 0) return null;
  return quotedItems.reduce((sum, item) => (
    sum + (Number(item.quotation?.totalInternalCost || 0) * Number(item.quantity || 0))
  ), 0);
};

const ROLE_SUPPLIER_NAME_FIELDS = ['supplierName', 'productionSupplierName', 'brandingSupplierName', 'deliverySupplierName'];

export const getQuoteSupplierNames = (record) => {
  if (Array.isArray(record.suppliers)) {
    return record.suppliers.map((supplier) => supplier.supplierName).filter(Boolean);
  }
  const names = new Set();
  (record.items || []).forEach((item) => {
    ROLE_SUPPLIER_NAME_FIELDS.forEach((field) => {
      if (item.quotation?.[field]) names.add(item.quotation[field]);
    });
  });
  return Array.from(names);
};
